import React from 'react';
import { Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface SystemStatusCardProps {
  totalReports: number;
  skimmerCount: number;
  noSkimmerCount: number;
}

export const SystemStatusCard: React.FC<SystemStatusCardProps> = ({
  totalReports,
  skimmerCount,
  noSkimmerCount,
}) => {
  return (
    <Box className="glass-panel data-card system-status-card">
      <div className="status-header">
        <span className="status-label">SYSTEM STATUS:</span>
        <span className="text-green">MONITORING ACTIVE</span>
      </div>

      <div className="metrics-row">
        <div className="metric-col metric-col-left">
          <div className="metric-title">Scans (30 days)</div>
          <div className="metric-value-row">
            <span className="large-number text-cyan">{totalReports}</span>
          </div>
          <div className="metric-subtext">
            <span><strong className="text-cyan">{noSkimmerCount}</strong> No skimmer</span>
            <span><strong className="text-muted">{skimmerCount}</strong> Need attention</span>
          </div>
        </div>

        <div className="vertical-divider" />

        <div className="metric-col metric-col-right critical-col">
          <div className="metric-title">Need attention (30 days)</div>
          <div className="metric-value-row">
            <div className="icon-container red-box">
              <WarningAmberIcon sx={{ fontSize: 22, color: '#ff3b3b' }} />
            </div>
            <span className="large-number text-red text-glow">{skimmerCount}</span>
          </div>
          <div className="metric-subtext">
            <span className="text-muted">Scans with skimmer detected</span>
          </div>
        </div>
      </div>
    </Box>
  );
};
